import { Typography, Form, Space, Button, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  getMonthlyReport,
  getReportByDate,
  getDatesOfReports,
} from "../../http-request/inbound-monitoring";
import { getUserEstablishment } from "../../http-request/user";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import Notification from "../../../components/shared/Notification";
import { COLORS } from "../../../constants";
import { formatDate } from "../../../helpers/formatDate";
import PageReportDatePicker from "../../components/PageReportDatePicker/PageReportDatePicker";

const { Text } = Typography;

const InboundMonitoringPage = () => {
  const [forms] = Form.useForm();
  const navigate = useNavigate();
  const [isDownloadingReport, setisDownloadingReport] = useState(false);
  const [isLoadingData, setisLoadingData] = useState(false);
  const [establishmentId, setestablishmentId] = useState();

  const loadUserEstablishment = async () => {
    let token = localStorage.getItem("token");
    let establishmentId = await getUserEstablishment(token);
    if (!establishmentId) {
      Notification("Error", "Error loading user establishment!", "error");
      return navigate(-1);
    }
    setestablishmentId(establishmentId);
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.white }} spin />
  );

  const loadReport = async () => {
    setisLoadingData(true);
    let date = formatDate(forms.getFieldValue("date"));
    if ((date, establishmentId)) {
      let token = localStorage.getItem("token");
      let record = await getReportByDate({ establishmentId, date }, token);

      if (record) {
        navigate(`${record.transactionId}`, { state: record });
      } else {
        navigate(`new-record`, {
          state: { date },
        });
      }
    } else {
      Notification("No selected date!", "", "error");
    }
    setisLoadingData(false);
  };

  useEffect(() => {
    loadUserEstablishment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppContainer title="Inbound Monitoring Report">
      <center>
        <div style={{ margin: "20px 0px", width: "60vw" }}>
          <Text type="secondary">Select date to add or edit report</Text>
          <Form
            form={forms}
            onFinish={async (values) => {
              setisDownloadingReport(true);
              values.date = formatDate(values.date);
              values.establishmentId = establishmentId;
              let token = localStorage.getItem("token");
              await getMonthlyReport(values, token)
                .then((res) => {
                  if (res?.downloadLink) {
                    window.open(res.downloadLink, "_blank");
                  }
                })
                .finally(() => {
                  setisDownloadingReport(false);
                  forms.resetFields();
                });
            }}
          >
            <PageReportDatePicker request={{ getDatesOfReports }} />
            <Space
              direction="vertical"
              style={{ width: "100%" }}
              size={"middle"}
            >
              <Button block type="primary" onClick={loadReport}>
                {isLoadingData ? (
                  <Spin indicator={antIcon} />
                ) : (
                  "EDIT / ADD REPORT"
                )}
              </Button>

              <Button
                block
                disable={isDownloadingReport || !establishmentId}
                type="primary"
                htmlType="submit"
                style={{ backgroundColor: COLORS.orange, border: 0 }}
              >
                {isDownloadingReport ? (
                  <Spin indicator={antIcon} />
                ) : (
                  "DOWNLOAD REPORT"
                )}
              </Button>
            </Space>
          </Form>
        </div>
      </center>
    </AppContainer>
  );
};

export default InboundMonitoringPage;
